import React, { useState } from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Frequentlyquestion from "./Frequentlyquestion.js";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function BasicTabs(props) {
  const [value, setValue] = useState(0);
  const [search, setSearch] = useState(""); // Search state for suitable cars

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // Filter suitable cars based on search input
  const filteredCars = props.data?.suitable_cars?.filter((car) =>
    car.name.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="SuitableCars">
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="سوالات متداول" {...a11yProps(0)} />
            <Tab label="خودورهای مناسب" {...a11yProps(1)} />
          </Tabs>
        </Box>

        {/* Frequently Questions Tab */}
        <TabPanel value={value} index={0}>
          {props.data?.frequently_questions?.length ? (
            <div className="questionSuitableCarsMain">
              {props.data.frequently_questions.map(
                (frequentlyquestion, idx) => (
                  <Frequentlyquestion
                    key={idx}
                    frequentlyquestion={frequentlyquestion}
                  />
                ),
              )}
            </div>
          ) : (
            <div className="outOfStockReason">
              سوالی برای این محصول موجود نیست
            </div>
          )}
        </TabPanel>

        {/* Suitable Cars Tab */}
        <TabPanel value={value} index={1}>
          {props.data?.suitable_cars?.length ? (
            <div className="suitableCars">
              {/* Search Input */}
              <div style={{ marginBottom: "16px" }}>
                <input
                  type="text"
                  placeholder="جستجوی خودرو..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  style={{
                    width: "100%",
                    padding: "8px",
                    borderRadius: "6px",
                    textAlign: "end",
                    border: "1px solid #ccc",
                  }}
                />
              </div>

              {/* Filtered Cars List */}
              <div className="RelatedCarsMain">
                {filteredCars?.length ? (
                  filteredCars.map((suitablecar) => (
                    <div
                      className="itemRelatedCars"
                      key={suitablecar.id || suitablecar.name}
                    >
                      {suitablecar.name}
                    </div>
                  ))
                ) : (
                  <div className="outOfStockReason">خودرویی یافت نشد</div>
                )}
              </div>
            </div>
          ) : (
            <div className="outOfStockReason">خودرو مناسبی موجود نیست</div>
          )}
        </TabPanel>
      </Box>
    </div>
  );
}
